import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const NewsOther = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    mounted(){
        let mpSwiperNews = new Swiper('.js-other-news-slider', {
            loop: true,
            lazyPreloadPrevNext: 2, // соседи видимых: Swiper снимает loading у их картинок — сигнал модулю lazyload.js
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 30,
            autoplay: {
              delay: 3000
            },
            navigation: {
              nextEl: ".js-other-news-next",
              prevEl: ".js-other-news-prev"
            },
            breakpoints: {
              320: {
                slidesPerView: 1.23,
                spaceBetween: 8
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 15
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            }
        });
    },
    template: `
<section class="section news__mp section--back" style="border-top: 1px solid #E7E7E7;">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
                    Другие новости и события
                </h2>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-other-news-prev">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-other-news-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper news__mp-slider js-other-news-slider">
            <div class="swiper-wrapper">

                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="swiper-slide">
                    <div class="news__item">
                        <a :href="item.LINK" class="news__item-img" :class="{'no-photo': item.PICTURE === false}">
                            <img v-if="item.PICTURE !== false" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME" loading="lazy">
                            <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                        </a>
                        <div class="news__item-info">
                            <div v-if="item.DATE !== false" class="news__item-date">
                                <div class="news__item-date-leftside">
                                    <span>{{item.DATE.day}}</span>
                                    {{item.DATE.month}}
                                </div>
                                <div class="news__item-date-year">
                                    ‘{{item.DATE.year}}
                                </div>
                            </div>
                            <a :href="item.LINK" class="news__item-name" v-html="item.NAME">
                            </a>
                            <div class="news__item-desc" v-html="item.TEXT">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
    `
}